import { render } from "./layoup-ve.vue?vue&type=template&id=0103464c"
import script from "./layoup-ve.vue?vue&type=script&lang=js"
export * from "./layoup-ve.vue?vue&type=script&lang=js"

import "./layoup-ve.vue?vue&type=style&index=0&id=0103464c&lang=scss"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__